import React, { useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import { Route, Routes } from 'react-router-dom';

import { Typography } from '@mui/material';

import AppTabs from '../../components/designe/app-tabs/AppTabs';
import PageContainer from '../../components/layout/page-container/PageContainer';
import { useGetMyDetails } from '../../services/redux/api/usersApi';
import { Paths } from '../../shared/paths';
import theme from '../../styles/theme';
import { useStyles } from './Settings.styles';
import { ChangePassword } from './change-password/ChangePassword';
import UserConfig from './user-config/UserConfig';
import UserInfo from './user-info/UserInfo';

function Settings(props) {
  const { t, i18n } = useTranslation();
  const { classes } = useStyles(theme);
  const { data: user } = useGetMyDetails();

  const tabsConfig = useMemo(() => {
    const config = [
      { label: t('settings.userInfo'), path: `${Paths.settings.root}` },
      {
        label: t('settings.userSettings'),
        path: `${Paths.settings.root}${Paths.settings.settings}`,
      },
    ];

    if (user.providerId === 'password') {
      config.push({
        label: t('settings.changePassword'),
        path: `${Paths.settings.root}${Paths.settings.changePassword}`,
      });
    }

    config.push({
      label: 'Typography test',
      path: `${Paths.settings.root}/typography`,
    });

    return config;
  }, [i18n.language, user]);

  return (
    <PageContainer title={t('settings.settings')}>
      <div className={classes.settingsWrapper}>
        <AppTabs config={tabsConfig} />
        <div className={classes.tabsContent}>
          <Routes>
            <Route path={'/'} element={<UserInfo />} />
            <Route path={Paths.settings.settings} element={<UserConfig />} />
            <Route
              path={Paths.settings.changePassword}
              element={<ChangePassword />}
            />
            <Route
              path={'/typography'}
              element={
                <div>
                  <Typography variant="h1">Variant H1 </Typography>
                  <Typography variant="h2">Variant H2 </Typography>
                  <Typography variant="h3">Variant H3 </Typography>
                  <Typography variant="h4">Variant H4 </Typography>
                  <Typography variant="text-lg">Variant text-lg </Typography>
                  <Typography variant="text-md">Variant text-md </Typography>
                  <Typography variant="text-md-sb">
                    Variant text-md-sb{' '}
                  </Typography>
                  <Typography variant="text-sm">Variant ext-sm </Typography>
                  <Typography variant="text-sm-sb">
                    Variant text-sm-sb{' '}
                  </Typography>
                  <Typography variant="button-lg">
                    Variant button-lg{' '}
                  </Typography>
                  <Typography variant="button-sm">
                    Variant button-sd{' '}
                  </Typography>
                </div>
              }
            />
          </Routes>
        </div>
      </div>
    </PageContainer>
  );
}

export default Settings;
